import React from 'react';
import { IconProps } from '.';

const SvgNew = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={(size && Math.floor(size / 1.15)) || 20}
      fill='none'
      viewBox='0 0 23 20'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <g fill={color}>
        <path
          fillRule='evenodd'
          d='M12.403 4.576c.384 0 .734.086 1.05.259.319.172.573.423.761.752.192.325.288.716.288 1.172 0 .104-.008.24-.024.41-.013.169-.03.309-.049.42h-3.78l-.009.107v.108c0 .325.06.589.18.79.124.202.282.35.474.445.192.094.393.141.601.141.319 0 .578-.055.776-.166.202-.113.352-.263.45-.449h1.064c-.075.296-.218.56-.43.791a2.21 2.21 0 0 1-.805.547c-.326.13-.7.195-1.123.195a2.46 2.46 0 0 1-1.133-.258 1.993 1.993 0 0 1-.801-.767c-.195-.338-.293-.747-.293-1.226 0-.488.068-.932.205-1.333.137-.403.329-.748.576-1.035.25-.29.547-.512.889-.669a2.716 2.716 0 0 1 1.133-.234Zm-.069.894c-.253 0-.485.057-.693.17-.205.111-.383.267-.532.47a2.189 2.189 0 0 0-.332.707h2.67a.52.52 0 0 0 .006-.088c.003-.042.005-.083.005-.122a1.21 1.21 0 0 0-.132-.566.995.995 0 0 0-.381-.415 1.128 1.128 0 0 0-.61-.156Z'
          clipRule='evenodd'
        />
        <path d='M7.28 8.101h.084L8.482 2.95h1.084l-1.5 7.046h-.961L4.59 4.864h-.078L3.394 9.996H2.31L3.809 2.95h.962l2.51 5.151ZM16.51 8.702h.083l1.91-4.023h1.044l.22 4.057h.083l1.826-4.057h1.05l-2.588 5.317h-1.094l-.283-3.892h-.078l-1.91 3.892H15.69l-.327-5.317h.986l.161 4.023Z' />
      </g>
    </svg>
  );
};

export default SvgNew;
